import React from 'react';

// tslint:disable: max-line-length
interface Props {
  width?: number;
  className?: string;
}
export default function Croix(props: Props) {
  return (
    <svg
      width={props.width ? props.width + 'px' : '20px'}
      className={props.className && props.className}
      height="20px"
      viewBox="0 0 20 20"
      version="1.1"
    >
      <title>Croix</title>
      <g id="BOARD-3---Icônes" transform="translate(-639.000000, -590.000000)" fill="#1B202D">
        <g id="Pictogrammes" transform="translate(305.000000, 178.000000)">
          <g id="18---Fermer" transform="translate(334.000000, 407.000000)">
            <path
              d="M19.6246538,22.853086 L19.6218217,22.8502541 L11.7761202,15.0050031 L19.6193043,7.16226932 C20.1156749,6.67952046 20.1284508,5.88299429 19.6470588,5.38451252 C19.40759,5.13656173 19.0858019,5 18.7409795,5 C18.4128349,5 18.1021234,5.12554869 17.8660531,5.35355013 C17.8567387,5.36254936 17.8473613,5.37186325 17.8381728,5.38136593 L9.9949887,13.2239738 L2.1492872,5.3787228 L2.14645511,5.37589088 L2.14356009,5.37305895 C1.90748983,5.1450575 1.59677833,5.01950882 1.26863375,5.01950882 C0.923811322,5.01950882 0.602023207,5.15607055 0.362554446,5.40402133 C-0.111348254,5.89463665 -0.111348254,6.66334702 0.362554446,7.15396234 L0.365386534,7.15685719 L0.368218622,7.15968912 L8.21392012,15.0049401 L0.368218622,22.8501912 C-0.122739541,23.341247 -0.122739541,24.1401646 0.368218622,24.6311575 C0.606176936,24.8690392 0.922426746,25 1.25881585,25 C1.59520495,25 1.91145476,24.8690392 2.14935014,24.6312833 L9.99505164,16.7860323 L17.8406902,24.6312204 L17.8435223,24.6341153 L17.8464173,24.6369472 C18.0824876,24.8649486 18.3931991,24.9904973 18.7213436,24.9904973 C19.0661661,24.9904973 19.3879542,24.8539356 19.627423,24.6059848 C20.1012627,24.1153066 20.1012627,23.3466591 19.627423,22.8560438 L19.6246538,22.853086 Z"
              id="icon"
            ></path>
          </g>
        </g>
      </g>
    </svg>
  );
}
